// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2CuR6","upload":"Small_upload__-r_Wa","imageWrap":"Small_imageWrap__3iuC6","removeBtn":"Small_removeBtn__wsU0a"};